import React from 'react'

const ProductContent = ({containerObject}) => {
  return (
    <>
        {containerObject && containerObject.targeterResult ? containerObject.targeterResult.map((oneContent)=>{
          return(<>
            <div dangerouslySetInnerHTML={{ __html: oneContent }}  ></div> 
          </>)
        })
       :""}

    </>
  )
}

export default ProductContent